// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"111ff2ad","304":"f7fb5c87","314":"84b135cf","368":"f7f6e10a","478":"52d7440b","746":"81debaa3","787":"b9566efd"}[chunkId] + ".chunk.js";
};